module.exports = __webpack_public_path__ + "435262291e3fe6b95812cebcf2d3de02.svg";